import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import uploads from './slices/uploadSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        uploads,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
